import { isBossWave, rollEnemyTypeForWave } from "../data/sectors"
import type { EnemyType } from "../types"

export const WAVE_GENERATOR_TUNING = {
  bossBandStartProgress: 0.72,
} as const

class WaveGenerator {
  rollEnemyType(wave: number, waveProgress = 0.5): EnemyType {
    return rollEnemyTypeForWave(wave, waveProgress)
  }

  rollEnemyGroup(wave: number, size: number, waveProgress = 0.5): EnemyType[] {
    const group: EnemyType[] = []
    for (let i = 0; i < size; i++) {
      group.push(this.rollEnemyType(wave, waveProgress))
    }
    return group
  }

  shouldSpawnBoss(wave: number): boolean {
    return isBossWave(wave)
  }
}

export const waveGenerator = new WaveGenerator()
